import { VoyagerKeyType } from '@mm/state/interfaces/voyagerLeads';

export const mapVoyagerAttributeItem = (
  attribute: VoyagerKeyType,
  item: string,
) => {
  switch (attribute as string) {
    case 'VOY_MARRIED':
      return {
        id: `${Boolean(item)}`,
        label:
          (typeof item === 'number' && item === 0) || item === 'false'
            ? 'Single'
            : 'Married',
      };

    case 'VOY_GENDER':
      return {
        id: item.toLowerCase(),
        label:
          item.toLowerCase() === 'f'
            ? 'Female'
            : item.toLowerCase() === 'm'
            ? 'Male'
            : 'Unknown',
      };
    case 'VOY_HOMEOWNER':
      return {
        id: `${Boolean(item)}`,
        label:
          (typeof item === 'number' && item === 1) || item === 'true'
            ? 'Owns home'
            : 'Does not own home',
      };
    default:
      return { id: item.toLowerCase(), label: item };
  }
};
